

export default [
	{
		path: '/offer/list',
		name: 'OfferList',
		component: () => import('../views/offer/list-view.vue'),
		meta: {
			title_key: 'router.offerList',
		},
	},
	{
		path: '/offer/list/activation',
		name: 'OfferListActivation',
		component: () => import('../views/offer/activation-view.vue'),
		meta: {
			title_key: 'router.offerListActivation',
		},
	},
	{
		path: '/messagecenter/list',
		name: 'MessageCenter',
		component: () => import('../views/message/center-view.vue'),
		meta: {
			title_key: 'router.messageCenter',
		},
		children: [
			{
				path: 'detail/:id',
				name: 'MessageDetail',
				component: () => import('../views/message/conversation-view.vue'),
				meta: {
					title_key: 'router.messageDetail',
				},
			},
		],
	},
	{
		path: '/offer/form/:id?',
		name: 'OfferForm',
		component: () => import('../views/offer/form-view.vue'),
		meta: {
			title_key: 'router.offerForm',
		},
	},
	{
		path: '/user/accept-invite',
		name: 'AcceptInvite',
		component: () => import('../views/user/invite.vue'),
		meta: {
			title_key: 'router.userInvite',
		},
	},
	{
		path: '/user/profile/:tab?',
		name: 'UserProfile',
		component: () => import('../views/user/profile-view.vue'),
		meta: {
			title_key: 'router.userProfile',
		},
	},
	{
		path: '/offer/approval',
		name: 'OfferApproval',
		component: () => import('../views/offer/approval-view.vue'),
		meta: {
			title_key: 'router.offerApproval',
		},
	},
	{
		path: '/offergroup/list',
		name: 'OffergroupList',
		component: () => import('../views/admin/offergroup/list-view.vue'),
		meta: {
			title_key: 'router.offergroupList',
		},
	},
	{
		path: '/offergroup/form/:id?',
		name: 'OffergroupForm',
		component: () => import('../views/admin/offergroup/form-view.vue'),
		meta: {
			title_key: 'router.offergroupForm',
		},
	},
	{
		path: '/sort/list',
		name: 'SortList',
		component: () => import('../views/sort/list-view.vue'),
		meta: {
			title_key: 'router.sortList',
		},
	},
	{
		path: '/sort/form/:id?',
		name: 'SortForm',
		component: () => import('../views/sort/form-view.vue'),
		meta: {
			title_key: 'router.sortForm',
		},
	},
	{
		path: '/species/list',
		name: 'SpeciesList',
		component: () => import('../views/admin/species/list-view.vue'),
		meta: {
			title_key: 'router.speciesList',
		},
	},
	{
		path: '/species/view/:id?',
		name: 'SpeciesDisplay',
		component: () => import('../views/admin/species/detail-view.vue'),
		meta: {
			title_key: 'router.speciesDisplay',
		},
	},
	{
		path: '/cms/list',
		name: 'CmsOverview',
		component: () => import('../views/cms/overview-view.vue'),
		meta: {
			title_key: 'router.cmsOverview',
		},
	},
	{
		path: '/cms/form/:id',
		name: 'CmsEdit',
		component: () => import('../views/cms/edit-view.vue'),
		meta: {
			title_key: 'router.cmsEdit',
		},
	},
	{
		path: '/cms/page/:id',
		name: 'CmsPage',
		component: () => import('../views/cms/page-view.vue'),
		meta: {
			title_key: 'router.cmsPage',
		},
	},
	{
		path: '/classification/list',
		name: 'ClassificationUpload',
		component: () => import('../views/classification/list-view.vue'),
		meta: {
			title_key: 'router.classificationUpload',
		},
	},
	{
		path: '/sup/self-register',
		name: 'RegisterSup',
		component: () => import('../views/user/self-register-sup.vue'),
		meta: {
			title_key: 'router.registerSup',
		},
	},
	{
		path: '/sup/list',
		name: 'CheckSups',
		component: () => import('../views/user/list-sups.vue'),
		meta: {
			title_key: 'router.checkSups',
		},
	},
	{
		path: '/sup/view/:id?',
		name: 'ViewSup',
		component: () => import('../views/user/aut-sup-view.vue'),
		meta: {
			title_key: 'router.viewSup',
		},
	},
	{
		path: '/cms/aut-statistics',
		name: 'RdbAutStatistics',
		component: () => import('../views/cms/rdb-aut-statistics.vue'),
		meta: {
			title_key: 'router.rdbAutStatistics',
		},
	},
	{
		path: '/rdb/faq',
		name: 'RdbFaq',
		component: () => import('../views/cms/rdb-faq.vue'),
		meta: {
			title_key: 'router.rdbFaq',
		},
	},
	{
		path: '/classification-monitor',
		name: 'ClassificationMonitor',
		component: () => import('../views/classification/classification-monitor.vue'),
		meta: {
			title_key: 'router.classificationMonitor',
		},
	},
	{
		path: '/aut/offer_export',
		name: 'AutOfferExport',
		component: () => import('../views/offer/offer-export-view.vue'),
		meta: {
			title_key: 'router.autOfferExport',
		},
	},
	{
		path: '/offer-sup/list',
		name: 'OfferSupList',
		component: () => import('../views/offer/offer-sup.vue'),
		meta: {
			title_key: 'components.menu.speciesManagement',
		},
	},
	{
		path: '/offer/mix-report',
		name: 'OfferMixReportExport',
		component: () => import('../views/offer/offer-export-view.vue'),
		meta: {
			title_key: 'router.offerMixReportExport',
		},
	},
	{
		path: '/offer/prm-report',
		name: 'OfferPrmReportExport',
		component: () => import('../views/offer/offer-export-view.vue'),
		meta: {
			title_key: 'router.offerPrmReportExport',
		},
	},
	{
		path: '/oxs/agb',
		name: 'AgbDescription',
		component: () => import('../views/cms/agb-view.vue'),
		meta: {
			title_key: 'router.agbDescription',
		},
	},
	{
		path: '/export/sup-offers',
		name: 'ExportSupOffers',
		component: () => import('../views/offer/offer-export-view.vue'),
		meta: {
			title_key: 'components.menu.exportOffers',
		},
	},
];
